import { clients } from '@/services/client.factory'
import authstore from '@/store/modules/auth';

const notifications = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        NOTIFICATION_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        NOTIFICATION_CREATE_ITEM(state, item) {
            state.items.push(item);
        },
        NOTIFICATION_UPDATE_ITEM(state, item) {
            Object.assign(state.items[item.editedIndex], item);
            //state.item = Object.assign({}, state.item, item)
        },
        NOTIFICATION_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
      
        NOTIFICATION_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        NOTIFICATION_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
    },
    actions: {
        getItem(context, id) {
        },
        async sendBroadcastMessage({ commit }, notification) {
            console.log("notify",notification)
            let jwt = authstore.getters.jwtDecoded(authstore.state);

            await clients.placeServiceClient.sendBroadCastMessage(jwt.city_code, notification.title, notification.text);
        }
    }
}

export default notifications;